import PropTypes from 'prop-types';
import React from 'react';

class SupportLoginCardRight extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="support-card-gradient mb-4">
        <div className="support-card-white-container pt-3 pb-3 pl-3">
          <div className="right-card-text-container">
            <div className="main-title">{this.props.mainTitle}</div>
            <div className="subtitle mb-md-4">
              <a href="mailto:support@promotionwingman.com">
                {this.props.subTitle}
              </a>
            </div>
            {this.props.bodyText && (
              <div className="body-text mt-md-0">{this.props.bodyText}</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

SupportLoginCardRight.propTypes = {
  mainTitle: PropTypes.string,
  subTitle: PropTypes.string,
  bodyText: PropTypes.string,
};

export default SupportLoginCardRight;
